import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { FolderActions } from '@features/dashboard/mon-stock/store/actions/folder.actions';
import { FolderService } from '@features/dashboard/mon-stock/services/folder.service';
import { FactureService } from '@features/dashboard/mon-stock/services/facture.service';

@Injectable()
export class FolderSummaryEffects {
  constructor(private actions$: Actions, private folderService: FolderService, private factureService: FactureService) { }

  loadFolderSummary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FolderActions.loadFolderSummary),
      mergeMap(action =>
        this.folderService.getFolderSummary(action.sirets).pipe(
          map(folderSummary => FolderActions.loadFolderSummarySuccess({ folderSummary })),
          catchError(error => of(FolderActions.loadFolderSummaryFailure({ error })))
        )
      )
    )
  );

  loadFactureSummary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FolderActions.loadBillSummary),
      mergeMap(action =>
        this.factureService.getBillsSummary(action.sirets).pipe(
          map(folderSummary => FolderActions.loadBillSummarySuccess({ folderSummary })),
          catchError(error => of(FolderActions.loadBillSummaryFailure({ error })))
        )
      )
    )
  );
}
